// @flow
import * as React from 'react';

import hoistNonReactStatics from 'hoist-non-react-statics';
import { UNSAFE_NavigationContext } from 'react-router-dom';

export type WithBasenameProps = {
  basename: string,
};

/**
 * Provides basename in the HoC way
 * @deprecated temporary solution for basename, please remove this when possible
 * This is temporary until `UNSAFE_NavigationContext` is being removed…
 */
export function withBasename(
  Component: React.ComponentType<any>,
): React.ComponentType<any> {
  function Wrapper(props: any) {
    const { basename } = React.useContext(UNSAFE_NavigationContext);

    return <Component basename={basename} {...props} />;
  }

  return hoistNonReactStatics(Wrapper, Component);
}
